const VERIFICATION_FLOW_STORAGE_KEY =
  "orthoprecision_verification_flow_in_progress";

const getSessionStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.sessionStorage;
};

export const isVerificationFlowInProgress = () =>
  getSessionStorage()?.getItem(VERIFICATION_FLOW_STORAGE_KEY) === "true";

export const setVerificationFlowInProgress = (value: boolean) => {
  const storage = getSessionStorage();
  if (!storage) return;

  if (value) {
    storage.setItem(VERIFICATION_FLOW_STORAGE_KEY, "true");
    return;
  }

  storage.removeItem(VERIFICATION_FLOW_STORAGE_KEY);
};

export const clearVerificationFlowInProgress = () => {
  setVerificationFlowInProgress(false);
};
